import { REWARDS_WIDGET_NAMES } from "@/constants/widget-names";
import { RewardsAvailableStoreCreditPageWidgetModalDefinition } from "@apps/rewards/constants/definitions";
import type { RewardsWidgetInjectorConfig } from "@apps/rewards/types";
import WidgetInjectedSdkEvent from "@modules/sdk/common_sdk/events/WidgetInjectedSdkEvent";
import { dispatchSdkEvent } from "@modules/sdk/helpers";

class RewardsAvailableStoreCreditPageWidgetModalInjector {
    constructor(private readonly config: RewardsWidgetInjectorConfig) {}

    start(): void {
        this.config.logger.debug(
            "RewardsAvailableStoreCreditPageWidgetModalInjector start",
            {
                placeholderSelector: this.config.placeholderSelector,
            }
        );

        const widgetName =
            REWARDS_WIDGET_NAMES.REWARDS_AVAILABLE_STORE_CREDIT_PAGE_WIDGET_MODAL;

        const targets$ = this.config.mutationObserverInjector.register({
            targetSelector: this.config.placeholderSelector,
        });

        targets$.subscribe((placeholder) => {
            this.config.logger?.debug(
                "RewardsAvailableStoreCreditPageWidgetModalInjector found placeholder",
                {
                    placeholder,
                }
            );

            void (async () => {
                const RewardsAvailableStoreCreditPageWidgetModal =
                    await this.config.dynamicImportManager.importDefault(
                        RewardsAvailableStoreCreditPageWidgetModalDefinition
                    );

                const widget = new RewardsAvailableStoreCreditPageWidgetModal(
                    {
                        target: placeholder,
                    },
                    this.config.logger
                );

                await widget.init();

                this.config.eventsCollector.pushEvent(
                    this.config.eventsFactory.createWidgetInjected(widgetName)
                );

                dispatchSdkEvent(new WidgetInjectedSdkEvent(widgetName));
            })();
        });
    }
}

export default RewardsAvailableStoreCreditPageWidgetModalInjector;
